var _style, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.557 6.045",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n:root {\n--black-600: #435370;\n--black-800: #2c384e;\n--primary-dark: #009de6;\n--primary-a25: rgb(51 185 247 / 0.25);\n--stroke: var(--black-600);\n--knob: var(--black-800);\n--accent: var(--primary-dark);\n}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-track-dark",
    x1: 0,
    y1: 4.498,
    x2: 27.517,
    y2: 4.498,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.158 .175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "var(--stroke)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "var(--stroke)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "var(--stroke)",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "track"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.158 3.615H6.94c1.058 0 1.19.53 1.72 1.058.337.338.926 1.06 2.513 1.06 1.588 0 2.117-.663 2.514-1.06s.66-1.058 1.72-1.058H26.36",
    fill: "none",
    stroke: "url(#grad-track-dark)",
    strokeWidth: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "knobs"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.278,
    cy: 2,
    r: 1.8,
    fill: "var(--primary-a25)",
    strokeWidth: 0.3,
    "data-knob": 1,
    "data-layer": "ring"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.278,
    cy: 2,
    r: 1,
    fill: "var(--accent)",
    "data-knob": 1,
    "data-layer": "inner"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.4,
    cy: 1.6,
    r: 1,
    fill: "var(--knob)",
    "data-knob": 0,
    "data-layer": "ring"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.158,
    cy: 1.6,
    r: 1,
    fill: "var(--knob)",
    "data-knob": 2,
    "data-layer": "ring"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio1);
export default __webpack_public_path__ + "static/media/radio1.6718096c8fb27ed7b59fdedabeb7f849.svg";
export { ForwardRef as ReactComponent };